import { NgComponentOutlet } from '@angular/common';
import { Component, computed, input, output } from '@angular/core';
import { PnycButtonComponent } from '@ui-kit/pnyc-button/pnyc-button.component';
import { PnycIconComponent } from '@ui-kit/pnyc-icon/pnyc-icon.component';
import { ToastStackItem } from '../../models/toast-stack-item';

const SCALE_STEP = 0.04;

@Component({
    selector: 'toast-stack-item',
    templateUrl: './toast-stack-item.component.html',
    styleUrl: './toast-stack-item.component.scss',
    host: {
        '[class.is-first]': 'stackIndex() === 0',
        '[class.is-collapsed-behind]': '!isExpanded() && stackIndex() > 0',
        '[class.is-hidden]': 'isHidden()',
        '[class.is-expanded]': 'isExpanded()',
        '[style.--stack-scale]': 'collapsedScale()',
        '[style.z-index]': 'zIndex()',
    },
    imports: [NgComponentOutlet, PnycIconComponent, PnycButtonComponent],
})
export class ToastStackItemComponent {
    readonly item = input.required<ToastStackItem>();
    readonly stackIndex = input.required<number>();
    readonly isExpanded = input.required<boolean>();
    readonly totalCount = input.required<number>();
    readonly maxVisibleLayers = input.required<number>();
    readonly cleared = output<string>();

    readonly isHidden = computed(() => !this.isExpanded() && this.stackIndex() >= this.maxVisibleLayers());

    readonly collapsedScale = computed(() => {
        const index = this.stackIndex();
        const max = this.maxVisibleLayers();

        return index >= max ? 0.85 : 1 - index * SCALE_STEP;
    });

    readonly zIndex = computed(() => this.totalCount() - this.stackIndex());

    onClick(event: MouseEvent): void {
        this.item().onClickAction?.(this.item(), this.stackIndex());
        this.onClose(event);
    }

    onClose(event: MouseEvent): void {
        event.stopPropagation();

        this.cleared.emit(this.item().id);
    }
}
